import type { NavigateFunction } from "react-router-dom";

import { FinalResultsBody } from "@/components/game/final-results/FinalResultsBody";
import { ResultsConfetti } from "@/components/game/final-results/ResultsConfetti";
import { mapFinalResultsFromHat } from "@/components/game/final-results/viewModel";
import { GamePanel } from "@/components/game/GamePanel";
import { PassAndPlayGameResultActions } from "@/components/GameResultActions";
import type { HatGameSession } from "@/domain/hat-game/types";
import type { ScreenModel } from "@/features/hat-game/hatSingleplayerAppTypes";
import type { HatSingleplayerAppController } from "@/features/hat-game/useHatSingleplayerApp";

export function hatResultsScreen(
  controller: HatSingleplayerAppController,
  session: HatGameSession,
  navigate: NavigateFunction,
): ScreenModel {
  const results = session.results;
  const vm = results ? mapFinalResultsFromHat(results) : null;

  return {
    content: (
      <section className="relative flex flex-1 flex-col pb-4">
        <ResultsConfetti />
        <div className="relative z-10">
          <GamePanel title="Final Results">
            {vm ? (
              <FinalResultsBody vm={vm} />
            ) : (
              <p className="text-typ-body text-muted-foreground">No results yet.</p>
            )}
          </GamePanel>
        </div>
      </section>
    ),
    actions: (
      <PassAndPlayGameResultActions
        onPickAnotherGame={() => navigate("/passnplay")}
        onPlayAgain={() => void controller.startNewGame()}
      />
    ),
  };
}
